const hashInitialState = {
    hash: {
        loading: false,
        error: null,
        data: null
    },
};

export default hashInitialState;